<mat-card>
    <mat-card-header>
        <mat-card-title>Add New Material</mat-card-title>
        <mat-card-subtitle class="subtitle-text-color-2 small-subtitle">
            Fill in the details below to add a new material to your supply inventory.
        </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content style="padding: 0px !important">
        <div style="width: 650px; max-width: 100%; padding: 0 16px 16px;">
            <mat-stepper [orientation]="(stepperOrientation$ | async) ?? 'horizontal'" linear>
                <mat-step label="Material details" [completed]="isStep1ValuesValid()">
                    <app-dynamic-forms-v2 [formMetaData]="step1Meta" [formFields]="step1Fields" [resetOnSubmit]="false"
                        (formSubmitted)="onStep1Next($event)">
                    </app-dynamic-forms-v2>
                    <div class="step-actions">
                        <!-- <button mat-flat-button color="primary" matStepperNext type="button">Next</button> -->
                    </div>
                </mat-step>

                <mat-step label="Packaging (optional)">

                    <app-dynamic-forms-v2 [formMetaData]="step2Meta" [formFields]="step2Fields" [resetOnSubmit]="false"
                        (formSubmitted)="onStep2Next($event)">
                    </app-dynamic-forms-v2>
                    <div class="step-actions tweak">
                        <button mat-button matStepperPrevious type="button">Back</button>
                        <!-- <button mat-flat-button color="primary" matStepperNext type="button">Next</button> -->
                    </div>
                </mat-step>

                <mat-step label="Total cost price">
                    <app-dynamic-forms-v2 [formMetaData]="step3Meta" [formFields]="step3Fields" [resetOnSubmit]="false"
                        (formSubmitted)="onStep3Next($event)">
                    </app-dynamic-forms-v2>
                    <div class="step-actions tweak">
                        <button mat-button matStepperPrevious type="button">Back</button>
                        <!-- <button mat-flat-button color="primary" type="button" (click)="saveMaterial()">Save
                            Material</button> -->
                    </div>
                </mat-step>
            </mat-stepper>
        </div>
    </mat-card-content>

    <mat-card-actions align="end">
        <button mat-button type="button" (click)="close()">Cancel</button>
    </mat-card-actions>
</mat-card>